import { findElement, findElementAll, selectedElementAll } from "../utils/element-handlers.utils";
import Swiper from 'swiper';
import { Pagination, Autoplay } from 'swiper/modules';
import NobuVideoFrame from "../objects/nobu-video-frame";
import { swiperSliderTabindexFix } from "../utils/swiper-utils";

interface SlideshowSlideObject {
    start: () => void,
    end: () => void
}

function SlideshowComponent(slideshowElement: HTMLElement) {
    const slideElementList = findElementAll('div.n-slideshow-slide', slideshowElement);
    const isOneSlide = slideElementList.length === 1;
    const swiper = new Swiper(slideshowElement, {
        loop: !isOneSlide,
        autoHeight: !slideshowElement.classList.contains('n-slideshow-fullscreen'),
        autoplay: isOneSlide ? false : {
            delay: 8000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            pauseOnMouseEnter: true,
        },
        pagination: isOneSlide ? false : {
            el: '.swiper-pagination',
            bulletClass: 'n-slideshow-pagination-bullet',
            bulletActiveClass: 'n-slideshow-pagination-bullet-active',
            clickable: true,
            renderBullet: function (index, className) {
                return `<button aria-label="Go to slide ${index + 1}" class="${className}"></button>`;
            },
        },
        modules: [
            Autoplay,
            Pagination,
        ],
    });
    const slideObjectList: SlideshowSlideObject[] = slideElementList
        .map(slideElement => {
            const videoFrameElement = findElement('div.n-video-frame', slideElement);
            const videoFrameInstance = videoFrameElement ? new NobuVideoFrame(videoFrameElement) : null;
            const videoInstance = videoFrameInstance ? videoFrameInstance.videoInstance : null;

            let slideIsStarted: boolean = false;

            videoInstance?.onUpdate(event => {
                if (event === 'ended') {
                    if (isOneSlide) {
                        videoInstance.play();
                    }
                    else {
                        swiper.slideNext();
                    }
                }
            });
    
            const start = () => {
                if (slideIsStarted) return;

                if (videoInstance) {
                    swiper.autoplay.stop();
                    videoInstance.play();
                }

                if (slideElement.parentElement) {
                    slideElement.parentElement.setAttribute('aria-current', 'true');
                }

                slideIsStarted = true;
            };
    
            const end = () => {
                if (!slideIsStarted) return;

                if (videoInstance) {
                    swiper.autoplay.start();
                    videoInstance.stop();
                }

                if (slideElement.parentElement) {
                    slideElement.parentElement.removeAttribute('aria-current');
                }

                slideIsStarted = false;
            };
    
            return {start, end};
        });

    swiper.on('slideChangeTransitionEnd', (swiper) => {
        startSlide(swiper.realIndex);
    });

    startSlide(0);
    swiperSliderTabindexFix(swiper);

    function startSlide(slideIndex: number) {
        let slideObjectToStart: SlideshowSlideObject | null = null;

        for (let i = 0; i < slideObjectList.length; i++) {
            if (i === slideIndex) {
                slideObjectToStart = slideObjectList[i];
            }
            else {
                slideObjectList[i].end();
            }
        }

        slideObjectToStart && slideObjectToStart.start();
    }
}

export default function initSlideshowComponent() {
    selectedElementAll('.n-slideshow', SlideshowComponent);
}
